

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Domain } from 'src/app/shared/model/model';

@Injectable()
export class DomainService {
    public queryEndPoint = 'query-api/Domain';
    constructor(private http: HttpClient) { }

    get = () => this.http.get<Domain[]>(`${this.queryEndPoint}`);
}
